// extracted by mini-css-extract-plugin
export default {"verticalSeperator":"button-seperator-module__verticalSeperator--o_Gym"};